import React, { forwardRef, useState } from "react";
import { days, daysEven, hours } from "../datas/timeDatas";
import ScheduleHeader from "./ScheduleHeader";

const ScheduleTable = forwardRef(({ schedules = [] }, ref) => {
  const [showPopup, setShowPopup] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);

  const handleClassClick = (classData, day, hour) => {    
    if (classData && classData.length > 0 && classData[0]) {
      const firstClass = classData[0];
      if (firstClass.link) {
        setSelectedVideo(firstClass.link);
        setShowPopup(true);
      }
    }
  };

  const closePopup = () => {
    setShowPopup(false);
    setSelectedVideo(null);
  };


  const containsLightAcademy = (text) => {
    if (!text) return false;
    return text.toLowerCase().includes('light academy');
  };

  // Function to extract YouTube video ID from URL
  const getYouTubeVideoId = (url) => {
    if (!url) return null;
    
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11) ? match[2] : null;
  };

  const videoId = getYouTubeVideoId(selectedVideo);

  return (
    <div className="d-flex">
      <div className="schedule-table-container">
        <div
          className="table-hour-gradient"
          style={{ display: "inline-block", width: "auto" }}
        >
          <table ref={ref} className="schedule-table">
            <thead className="">
              <tr>
                <th className="schedule-th-empty"></th>
                {days.map((day) => (
                  <th
                    key={day}
                    className="schedule-th-day me-2 position-sticky z-3"
                  >
                    <ScheduleHeader day={day} />
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {hours.length > 0 &&
                hours.map((hour) => (
                  <tr key={hour}>
                    <td className="hour-cell">{hour}</td>
                    {days.map((day) => {
                      const daySchedule =
                        schedules.length > 0
                          ? schedules.find((d) => d.day === day)
                          : null;
                      const classDataDay = daySchedule?.schedule?.morning?.concat(
                        daySchedule?.schedule?.noon || []
                      ) || [];

                      const digitTime = hour?.split(":")[0];
                      const classData = classDataDay?.filter((c) => {
                        const startHour = c?.start_time?.split(":")[0];
                        const isSameHour = startHour === digitTime;
                        const isLightAcademy =
                          containsLightAcademy(c?.class_name) ||
                          containsLightAcademy(c?.instruktur_name);
                        return isSameHour && !isLightAcademy;
                      }) || [];

                      const dayColor = daysEven.includes(day)
                        ? "var(--neutral-light-blue)"
                        : "var(--neutral-white)";
                      
                      if (!classData || classData.length === 0) {
                        return (
                          <td
                            key={`${day}-${hour}-empty`}
                            className="empty-cell"
                            style={{ background: dayColor, padding: "10px" }}
                          ></td>
                        );
                      }
                      
                      return (
                        <td
                          key={`${day}-${hour}-class-cell`}
                          className="class-cell text-start"
                          style={{
                            background: dayColor,
                            color: "#fff",
                            padding: "10px",
                          }}
                          onClick={() => handleClassClick(classData, day, hour)}
                        >
                          {classData?.map((c, index) => (
                            <div key={`${day}-${hour}-${index}`} className="class-details">
                              <div className="class-header">
                                <span className="class-time">
                                  {c.start_time} - {c.end_time}
                                </span>
                                {c?.club_name && (
                                  <div className="class-club">
                                    <i className="bi bi-geo-alt-fill"></i>
                                    <span>{c.club_name}</span>
                                  </div>
                                )}
                                <span
                                  className="class-dot"
                                  style={{
                                    background: c.bg_color,
                                    marginRight: "5px",
                                  }}
                                ></span>
                                <span className="class-name">
                                  {c.class_name}
                                </span>
                              </div>
                              <div
                                className="class-instructor"
                                style={{ marginTop: "5px" }}
                              >
                                <span>{c?.instruktur_name}</span>
                              </div>
                            </div>
                          ))}
                        </td>
                      );
                    })}
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* YouTube Video Popup */}
      {showPopup && videoId && (
        <div 
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'var(--gradient-blue)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999,
          }}
          onClick={closePopup}
        >
          <div 
            style={{
              position: 'relative',
              width: '80%',
              maxWidth: '800px',
              backgroundImage: 'var(--gradient-blue)',
              borderRadius: '8px',
              padding: '20px',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={closePopup}
              style={{
                position: 'absolute',
                top: '10px',
                right: '15px',
                background: 'none',
                border: 'none',
                fontSize: '24px',
                cursor: 'pointer',
                color: '#333',
                zIndex: 1,
              }}
            >
              ×
            </button>
            <div style={{ width: '100%', paddingTop: '56.25%', position: 'relative' }}>
              <iframe
                width="100%"
                height="100%"
                src={`https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1`}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  borderRadius: '4px',
                }}
              ></iframe>
            </div>
          </div>
        </div>
      )}
    </div>
  );
});

export default ScheduleTable;
